import { NgModule } from "@angular/core";

import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UploadComponent } from './upload/upload.component';
import { DownloadComponent } from './download/download.component';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { HomeComponent } from './home/home.component';
import { MenuComponent } from './menu/menu.component';
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTabsModule } from "@angular/material/tabs";
import { AuthenticationGuard } from "./auth/guards/authentication.guard";
import { UploadsStatusComponent } from './upload/uploads-status/uploads-status.component';
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatDividerModule } from "@angular/material/divider";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { SignInComponent } from './sign-in/sign-in.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthorizationGuard } from "./auth/guards/authorization.guard";
import { AuthorizeComponent } from './authorize/authorize.component';
import { InternalGuard } from "./auth/guards/internal.guard";
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { NgxFilesizeModule } from "ngx-filesize";
import { ShareFilesComponent } from './upload/share-files/share-files.component';
import { MatChipsModule } from "@angular/material/chips";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatListModule } from "@angular/material/list";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { TokenInterceptor } from "./interceptors/token.interceptor";
import { DatePipe } from "@angular/common";
import { TranslateComponent } from './translate/translate.component';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from '@angular/material/select';
const materialModules = [
  MatIconModule,
  MatButtonModule,
  MatInputModule,
  MatFormFieldModule,
  MatProgressBarModule
];

@NgModule({
  declarations: [
    AppComponent,
    DownloadComponent,
    UploadComponent,
    HomeComponent,
    MenuComponent,
    UploadsStatusComponent,
    SignInComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    AuthorizeComponent,
    DragAndDropDirective,
    ShareFilesComponent,
    TranslateComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot([
      { path: "", component: HomeComponent },
      { path: "upload", component: UploadComponent, canActivate: [AuthorizationGuard, AuthenticationGuard] },
      { path: "download", component: DownloadComponent, canActivate: [AuthenticationGuard] },
      { path: "authorize", component: AuthorizeComponent, canActivate: [AuthenticationGuard, InternalGuard] },
      { path: "translate", component: TranslateComponent, canActivate: [AuthenticationGuard, InternalGuard] }

    ]),
    ...materialModules,
    MatToolbarModule,
    MatCheckboxModule,
    MatSelectModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatDividerModule,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    NgxFilesizeModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatGridListModule,
    MatListModule,
    MatTooltipModule,
    MatSlideToggleModule
  ],
  exports: [
    ...materialModules
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  },
    DatePipe,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
